import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { getLanguage } from "./lang/index";
import enLang from "element-ui/lib/locale/lang/en";

// Plugins
import Element from "element-ui";
import i18n from "./lang";
// Components
import Api from "./api";
import sContainer from "./components/sContainer.vue";
import cContainer from "./components/cContainer.vue";
import Dialog from "./components/Dialog.vue";
import CountrySelection from "./components/CountrySelection";
import Uploader from "./components/Uploader";
import Filters from "./components/Filters";
import Basket from "./components/Basket";
import ShopCart from "./components/Cart";
import NavBar from "./components/NavBar";
// SCSS
import "./assets/sass/app.scss";
// 添加打印插件
import Print from "vue-print-nb";
import vcolorpicker from "vcolorpicker";
import VueAwesomeSwiper from "vue-awesome-swiper";
import CollapseTransition from "element-ui/lib/transitions/collapse-transition";
import "swiper/css/swiper.css";
import "element-ui/lib/theme-chalk/base.css";

import VideoPlayer from "vue-video-player";
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'

import "font-awesome/css/font-awesome.min.css";
import initRichText from "./initHTMLEditor.js";

Vue.config.productionTip = false;
Vue.use(Print); // 注册
Vue.use(VideoPlayer);
Vue.use(vcolorpicker);
Vue.use(VueAwesomeSwiper);
Vue.use(initRichText);
// Vue.component(Button.name, Button)
Vue.component("cContainer", cContainer);
Vue.component("sContainer", sContainer);
Vue.component("Dialog", Dialog);
Vue.component(CollapseTransition.name, CollapseTransition);
Vue.use(Api);
Vue.use(Uploader);
Vue.use(Filters);
Vue.use(Basket);
Vue.use(ShopCart);
Vue.use(NavBar);
Vue.use(Element, {
  locale: getLanguage() == "zh" ? null : enLang
});
Vue.prototype.$countrySelection = CountrySelection;
Vue.prototype.$bus = new Vue();
// 新版首页（views/homeNew）：滚动淡入指令
import { reveal } from "./views/homeNew/nh-reveal";
Vue.directive("reveal", reveal);
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  if (to.matched.some(record => record.meta.requireAuth)) {
    if (store.getters.isLogging) {
      // 审核通过不允许跳到此页面202005
      if (
        to.name === "certification" &&
        store.state.supplier.supplierInfo.IsChecked === (1 | 0)
      ) {
        next({
          path: "/"
        });
      } else {
        if (store.getters.getLoginType == "C") {
          next({
            path: "/cUser"
          });
        } else if (store.getters.getLoginType == "SU") {
          next({
            path: "/supplier"
          });
        } else {
          next();
        }
      }
    } else {
      next({
        path: "/login",
        query: { redirect: to.fullPath }
      });
    }
  } else {
    next();
  }
});

new Vue({
  el: "#app",
  router,
  store,
  i18n,
  render: h => h(App)
});
